module.exports = __webpack_public_path__ + "img/flag-MY.1a33f304.png";